import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Flex, HeadlineTitle, Loader } from '../../../../ui';
import { useAppDispatch, useAppSelector } from '../../../../hooks/appHooks';
import { LoginSelectors, LoginThunks } from '../../login/redux';
import { NoMarginBodyText } from '../../tfa/components/styled';
import { FooterButtons } from '../../tfa/components/FooterButtons';
import { ChoiceButton } from './ChoiceButton';
import { StyledButtonContainer } from './styled';
import { TfaMail } from '../../tfaMail';
import { TfaForm } from '../../tfa';
import { TfaTypes, UserLoginDto } from '../../../../types/User';
import { useSidePopout } from '../../../../layout';

interface TfaChoiceProps {
  userLoginDto: UserLoginDto;
}

export const TfaChoice: React.FC<TfaChoiceProps> = ({ userLoginDto }) => {
  const tfaVerifyLoading = useAppSelector(LoginSelectors.selectUserLoading);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { changePopoutContainer } = useSidePopout();

  const handleGoogleAuthenticatorChoice = (provider: TfaTypes) =>
    dispatch(LoginThunks.chooseTfaProvider(provider)).then((res) => {
      res.type === 'auth/tfaVerifyCode/fulfilled' && history.push('/');
      if (provider === TfaTypes.GOOGLE_AUTHENTICATOR) {
        changePopoutContainer({
          newContainer: <TfaForm qrCode={res.payload} />,
          urlKey: 'authorize',
        });
      }
      if (provider === TfaTypes.MAIL) {
        changePopoutContainer({
          newContainer: <TfaMail />,
          urlKey: 'authorize',
        });
      }
    });

  return (
    <Loader active={tfaVerifyLoading}>
      <Flex>
        <HeadlineTitle>{t('landingPage.tfaChoiceForm.title')}</HeadlineTitle>
        <NoMarginBodyText>
          {t('landingPage.tfaChoiceForm.descriptionText')}
        </NoMarginBodyText>
        <StyledButtonContainer>
          <ChoiceButton
            text={t('landingPage.tfaChoiceForm.buttonChoiceOne')}
            centered
            titleText={t('landingPage.tfaChoiceForm.buttonChoiceOneTitleText')}
            onSubmit={() =>
              handleGoogleAuthenticatorChoice(TfaTypes.GOOGLE_AUTHENTICATOR)
            }
          />
          <ChoiceButton
            text={t('landingPage.tfaChoiceForm.buttonChoiceTwo')}
            centered
            titleText={t('landingPage.tfaChoiceForm.buttonChoiceTwoTitleText')}
            onSubmit={() => handleGoogleAuthenticatorChoice(TfaTypes.MAIL)}
          />
        </StyledButtonContainer>
        <FooterButtons />
      </Flex>
    </Loader>
  );
};
